import { render, staticRenderFns } from "./entry.vue?vue&type=template&id=b996ed26&scoped=true"
import script from "./entry.vue?vue&type=script&lang=js"
export * from "./entry.vue?vue&type=script&lang=js"
import style0 from "./entry.vue?vue&type=style&index=0&id=b996ed26&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b996ed26",
  null
  
)

export default component.exports